import { PluginRegistry } from './engine/core/plugin-registry';
import { ServiceLocator } from './engine/core/service-locator';
import { EventBus } from './engine/events/event-bus';
import { saveCsv, saveVariable } from './engine/utils/saveVariable';
import HorizonsAPI from './engine/ootk/src/fetch/horizons';
export class KeepTrackApi {
    analytics = {
        identify: () => {
            // do nothing
        },
        track: () => {
            // do nothing
        },
        page: () => {
            // do nothing
        },
        user: () => ({
            anonymousId: '',
            id: '',
        }),
        reset: () => {
            // do nothing
        },
        ready: () => Promise.resolve(),
        on: () => {
            // do nothing
        },
        once: () => {
            // do nothing
        },
        getState: () => ({
            plugins: {},
        }),
    };
    containerRoot = null;
    isInitialized = false;
    // UI related methods
    toast(toastText, type, isLong = false) {
        const uiManagerInstance = ServiceLocator.getUiManager();
        if (!uiManagerInstance) {
            console.error(toastText);
            return;
        }
        uiManagerInstance.toast(toastText, type, isLong);
    }
    // Event bus methods
    on = EventBus.getInstance().on.bind(EventBus.getInstance());
    once = EventBus.getInstance().once.bind(EventBus.getInstance());
    emit = EventBus.getInstance().emit.bind(EventBus.getInstance());
    unregister = EventBus.getInstance().unregister.bind(EventBus.getInstance());
    events = EventBus.getInstance().events;
    methods = EventBus.getInstance().methods;
    // Plugin registry methods
    getPlugin = PluginRegistry.getPlugin.bind(PluginRegistry);
    checkIfLoaded = PluginRegistry.checkIfLoaded.bind(PluginRegistry);
    getPluginByName = PluginRegistry.getPluginByName.bind(PluginRegistry);
    unregisterAllPlugins = PluginRegistry.unregisterAllPlugins.bind(PluginRegistry);
    // Service locator methods
    getSoundManager = ServiceLocator.getSoundManager.bind(ServiceLocator);
    getRenderer = ServiceLocator.getRenderer.bind(ServiceLocator);
    getScene = ServiceLocator.getScene.bind(ServiceLocator);
    getCatalogManager = ServiceLocator.getCatalogManager.bind(ServiceLocator);
    getSensorManager = ServiceLocator.getSensorManager.bind(ServiceLocator);
    getUiManager = ServiceLocator.getUiManager.bind(ServiceLocator);
    getInputManager = ServiceLocator.getInputManager.bind(ServiceLocator);
    getGroupsManager = ServiceLocator.getGroupsManager.bind(ServiceLocator);
    getTimeManager = ServiceLocator.getTimeManager.bind(ServiceLocator);
    getOrbitManager = ServiceLocator.getOrbitManager.bind(ServiceLocator);
    getColorSchemeManager = ServiceLocator.getColorSchemeManager.bind(ServiceLocator);
    getDotsManager = ServiceLocator.getDotsManager.bind(ServiceLocator);
    getSensorMath = ServiceLocator.getSensorMath.bind(ServiceLocator);
    getLineManager = ServiceLocator.getLineManager.bind(ServiceLocator);
    getHoverManager = ServiceLocator.getHoverManager.bind(ServiceLocator);
    getMainCamera = ServiceLocator.getMainCamera.bind(ServiceLocator);
    getMeshManager = ServiceLocator.getMeshManager.bind(ServiceLocator);
    // Save utilities
    saveCsv = saveCsv;
    saveVariable = saveVariable;
    horizonsApi = new HorizonsAPI();
}
export const keepTrackApi = new KeepTrackApi();
